import {
  CorrelationComparisonMode,
  CorrelationEndpointSource
} from '../../../@types/projects/types';

export const ENDPOINT_SOURCE_LABELS: Record<CorrelationEndpointSource, string> =
  {
    lab: 'Lab values',
    refinement: 'Refinement values'
  };

export const ENDPOINT_COMPARISON_MODE_LABELS: Record<
  CorrelationComparisonMode,
  string
> = {
  off: 'Single source',
  overlay: 'Overlay comparison'
};

export const DEFAULT_ENDPOINT_SOURCE: CorrelationEndpointSource = 'lab';
export const DEFAULT_ENDPOINT_COMPARISON_MODE: CorrelationComparisonMode =
  'off';
